"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _orderInfo = require("@/api/order/orderInfo");
var _shopList = require("@/api/shop/shopList");
var _payment = require("@/api/order/payment");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
// import { get } from 'sortablejs'

var payStatusOptions = [{
  key: 0,
  value: '未付款'
}, {
  key: 1,
  value: '付款中'
}, {
  key: 2,
  value: '已付款'
}];
var payStatusKeyValue = payStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var shippingStatusOptions = [{
  key: 0,
  value: '未发货'
}, {
  key: 1,
  value: '已发货'
}, {
  key: 2,
  value: '已收货'
}, {
  key: 3,
  value: '备货中'
}, {
  key: 4,
  value: '部分发货'
}, {
  key: 5,
  value: '发货中（处理分单）'
}, {
  key: 6,
  value: '已选仓'
}];
var shippingStatusKeyValue = shippingStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var orderStatusOptions = [{
  key: 0,
  value: '未确认'
}, {
  key: 1,
  value: '已确认'
}, {
  key: 2,
  value: '已取消'
}, {
  key: 3,
  value: '无效'
}, {
  key: 4,
  value: '退货'
}, {
  key: 5,
  value: '已分单'
}, {
  key: 6,
  value: '部分分单'
}, {
  key: 7,
  value: '已完结'
}];
var orderStatusKeyValue = orderStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var _default = exports.default = {
  name: 'goodsManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    payStatusFilter: function payStatusFilter(key) {
      return payStatusKeyValue[key];
    },
    orderStatusFilter: function orderStatusFilter(key) {
      return orderStatusKeyValue[key];
    },
    shippingStatusFilter: function shippingStatusFilter(key) {
      return shippingStatusKeyValue[key];
    }
  },
  props: {
    userId: {
      type: [String, Number],
      default: null
    },
    abnormalFlag: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        orderSn: null,
        storeId: null,
        payId: null,
        orderSaleType: null,
        groupType: null,
        platform: null,
        userId: null,
        addBeginTime: null,
        addEndTime: null,
        abnormalFlag: this.abnormalFlag,
        activeName: 'all'
      },
      resPath: process.env.VUE_IMAGE_PATH,
      shopList: [],
      payTypeList: [],
      timeRange: [],
      abnormalDetailVisible: false,
      abnormalDetailLoading: false,
      abnormalDetailList: [],
      abnormalDetailTotal: 0,
      abnormalDetailQuery: {
        page: 1,
        limit: 10,
        orderSn: null
      },
      // 点餐数据详情弹窗
      diningDataVisible: false,
      diningDataLoading: false,
      diningData: null
    };
  },
  created: function created() {
    var _this = this;
    // 从 props 或路由参数中获取 userId
    if (this.userId) {
      this.listQuery.userId = this.userId;
    } else if (this.$route.query.userId) {
      this.listQuery.userId = this.$route.query.userId;
      // 清除路由参数，避免刷新后仍然使用
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          userId: undefined
        })
      });
    }
    this.getList();
    (0, _shopList.getStoreData)().then(function (res) {
      if (res) {
        _this.shopList = res.records;
      }
    });
    (0, _payment.getPayTypeList)().then(function (res) {
      if (res) {
        _this.payTypeList = res.records;
      }
    });
  },
  computed: {},
  watch: {
    abnormalFlag: {
      handler: function handler(newVal) {
        this.listQuery.abnormalFlag = newVal;
        this.handleFilter();
      },
      immediate: false
    }
  },
  methods: {
    handleClickTab: function handleClickTab(tab, event) {
      this.handleFilter();
    },
    openEditInTab: function openEditInTab(row) {
      this.$emit('open-edit', {
        id: row.orderId,
        title: "\u8BE6\u60C5 - ".concat(row.orderSn)
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      // 如果 abnormalFlag 为 0，则不传递该参数
      var query = _objectSpread({}, this.listQuery);
      if (query.abnormalFlag === 0) {
        delete query.abnormalFlag;
      }
      (0, _orderInfo.queryPage)(query).then(function (response) {
        if (response) {
          _this2.dataList = response.records;
          _this2.total = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    },
    handleDownload: function handleDownload(row) {
      var url = row.redPdfUrl || row.pdfUrl;
      if (url) {
        window.open(url, '_blank');
      }
    },
    handleCorrectStatus: function handleCorrectStatus(row) {
      var _this3 = this;
      this.$confirm('确定要修正此订单状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderInfo.correctStatus)({
          orderId: row.orderId
        }).then(function (response) {
          if (response && response.code == 200) {
            _this3.$message.success('修正状态成功');
            _this3.getList(); // 刷新列表
          } else {
            _this3.$message.error(response && response.message || '修正状态失败');
          }
        }).catch(function (error) {
          // this.$message.error((error && error.message) || '修正状态失败');
        });
      }).catch(function () {
        // this.$message.info('已取消操作');
      });
    },
    handlePushOrder: function handlePushOrder(row) {
      var _this4 = this;
      this.$confirm('确定要推送此订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderInfo.pushOrder)({
          orderId: row.orderId
        }).then(function (response) {
          if (response && response.code === 200) {
            _this4.$message.success('推送订单成功');
            _this4.getList(); // 刷新列表
          } else {
            _this4.$message.error(response && response.message || '推送订单失败');
          }
        }).catch(function (error) {
          _this4.$message.error(error && error.message || '推送订单失败');
        });
      }).catch(function () {
        // this.$message.info('已取消操作');
      });
    },
    handleConfirmReceive: function handleConfirmReceive(row) {
      var _this5 = this;
      this.$confirm('确定要确认收货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderInfo.confirmReceive)({
          orderId: row.orderId
        }).then(function (response) {
          if (response && response.code === 200) {
            _this5.$message.success('确认收货成功');
            _this5.getList(); // 刷新列表
          } else {
            _this5.$message.error(response && response.message || '确认收货失败');
          }
        }).catch(function (error) {
          _this5.$message.error(error && error.message || '确认收货失败');
        });
      }).catch(function () {
        // this.$message.info('已取消操作');
      });
    },
    handleEliminateException: function handleEliminateException(row) {
      var _this6 = this;
      this.$confirm('确定要消除此订单的异常状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderInfo.eliminateException)({
          orderId: row.orderId
        }).then(function (response) {
          if (response && response.code === 200) {
            _this6.$message.success('消除异常成功');
            _this6.getList(); // 刷新列表
          } else {
            _this6.$message.error(response && response.message || '消除异常失败');
          }
        }).catch(function (error) {
          _this6.$message.error(error && error.message || '消除异常失败');
        });
      }).catch(function () {
        // this.$message.info('已取消操作');
      });
    },
    handleShowAbnormalDetail: function handleShowAbnormalDetail(row) {
      this.abnormalDetailQuery.orderSn = row.orderSn;
      this.abnormalDetailQuery.page = 1;
      this.abnormalDetailVisible = true;
      this.getAbnormalDetailList();
    },
    getAbnormalDetailList: function getAbnormalDetailList() {
      var _this7 = this;
      this.abnormalDetailLoading = true;
      (0, _orderInfo.getAbnormalOrderPage)(this.abnormalDetailQuery).then(function (response) {
        if (response) {
          _this7.abnormalDetailList = response.records;
          _this7.abnormalDetailTotal = response.total;
        }
        _this7.abnormalDetailLoading = false;
      }).catch(function () {
        _this7.abnormalDetailLoading = false;
      });
    },
    handleAbnormalDetailPageChange: function handleAbnormalDetailPageChange(page) {
      this.abnormalDetailQuery.page = page;
      this.getAbnormalDetailList();
    },
    handleAbnormalDetailSizeChange: function handleAbnormalDetailSizeChange(size) {
      this.abnormalDetailQuery.limit = size;
      this.abnormalDetailQuery.page = 1;
      this.getAbnormalDetailList();
    },
    // 点餐数据详情相关方法
    handleShowDiningData: function handleShowDiningData(row) {
      var _this8 = this;
      this.diningDataVisible = true;
      this.diningDataLoading = true;
      this.diningData = null;
      (0, _orderInfo.getDiningData)(row.orderId).then(function (response) {
        if (response) {
          _this8.diningData = response;
        }
        _this8.diningDataLoading = false;
      }).catch(function () {
        _this8.diningDataLoading = false;
      });
    },
    // 处理时间范围变化
    handleTimeRangeChange: function handleTimeRangeChange(value) {
      if (value && value.length === 2) {
        this.listQuery.addBeginTime = value[0];
        this.listQuery.addEndTime = value[1];
      } else {
        this.listQuery.addBeginTime = null;
        this.listQuery.addEndTime = null;
      }
    }
  }
};